// extracted by mini-css-extract-plugin
export default {"list":"ReviewThumbs_list__aljbH","itemThumbSpan":"ReviewThumbs_itemThumbSpan__FJX88","reviewThumbs":"ReviewThumbs_reviewThumbs__LnvIe"};